import * as React from 'react'
import TextContainer from '../layout/TextContainer';




type Props = {

}

const LandingDescription: React.FC<Props> = ({ }: Props) => {


    return (
        <TextContainer className="text-lg">
            <h2 className="font-bold text-2xl text-gray-600 pb-4">Route Finder</h2>
            <p>Lightning Router determines the shortest route from the source node to the target node in the Lightning network.
            It does this by downloading the current Lightning Network graph and calculating the shortest path according to
                the <a className="text-gray-700 italic" target="_blank" href="https://lightning.readthedocs.io/lightning-getroute.7.html">
                    c-lightning getroute
                    </a> specification.

            </p>
            <h2 className="font-bold text-lg text-gray-600 mt-8 pb-2">How Are Fees Calculated?</h2>
            <p>Every node in the route charges a certain fee. The fee consists of a
                constant base fee and an amount dependend fee per millionth.</p>

            <p>For example, we send 5'000 satoshi and the router node has a base fee of 300msat and a variable fee of 100msat.
                </p>
            <p>Formula: <span className="code">base fee</span> + <span className="code">fee per millionth</span> * <span className="code">millisatoshis</span> / 1'000'000 = <span className="code">fee</span></p>
            <p>
                Example: <span className="code">300msat</span> + <span className="code">100msat</span> * <span className="code">5'000'000msat</span> / 1'000'000 = <span className="code">800msat</span>
            </p>
            <h2 className="font-bold text-lg text-gray-600 mt-8 pb-2">Why Does My Payment Fail Even Though There Is A Route?</h2>
            <p>
                A route from source to target does not guarantuee a successful payment.
                In the lightning network, channels have an inbound and outbound balance.
                If just one channel on the route is unbalanced the payment will fail.
                Unfortunately, channel balances are not publicly available
                and can not be included in the route calculation.
            </p>
        </TextContainer>

    );
}

export default LandingDescription;



